import Button from "components/common/Button";
import ActionCardDialogsContext from "components/features/ActionCard/Context";
import {
  flowOptions,
  setCustomPlanCreationFlow,
  setPlanMode
} from "components/features/CustomPlanCreation/CustomPlanCreation.slice";
import { useTranslate } from "hooks/useTranslate";
import React from "react";
import { useAppDispatch } from "redux/hooks";
import { formTypes } from "utils/Types";

const CreateTemplatePlanButton = () => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const { setIsOpenCustomPlanCreateDialog } = React.useContext(ActionCardDialogsContext);

  const createTemplatePlans = () => {
    dispatch(setPlanMode(formTypes.CreateTemplatePlan));
    dispatch(setCustomPlanCreationFlow(flowOptions["third"]));
    setIsOpenCustomPlanCreateDialog(true);
  };

  return (
    <div className="selected-plan">
      <Button
        className="create-template-plans"
        variant="primary"
        label={translate("custom.template.plan.creation.title")}
        onClick={createTemplatePlans}
      />
    </div>
  );
};

export default CreateTemplatePlanButton;
